export default "__VITE_ASSET__x4i$oxa3__"